import { render } from "./InvitationFuneralListForm.vue?vue&type=template&id=300f5568&lang=true"
import script from "./InvitationFuneralListForm.vue?vue&type=script&lang=js"
export * from "./InvitationFuneralListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__